export const HotelServicesAndConveniences = {
  'Luggage delivery service': {
    icon: 'ficon-luggage-storage',
  },
  ATM: {
    icon: 'ficon-confirmation-instant',
  },
  'Taking photos in the building': {
    icon: 'ficon-confirmation-instant',
  },
  'Convenience store': {
    icon: 'ficon-drug-stores',
  },
  Concierge: {
    icon: 'ficon-concierge',
  },
  'Game center': {
    icon: 'ficon-regular-go-game',
  },
  Laundromat: {
    icon: 'ficon-laundromat',
  },
  'Beauty spa': {
    icon: 'ficon-pin-spas',
  },
  Gym: {
    icon: 'ficon-gym',
  },
  'Foot bath': {
    icon: 'ficon-confirmation-instant',
  },
  'Karaoke room': {
    icon: 'ficon-karaoke',
  },
  Bar: {
    icon: 'ficon-mini-bar',
  },
  'Miniature golf': {
    icon: 'ficon-golf-course-on-site',
  },
  Tennis: {
    icon: 'ficon-regular-tennis-racket-rental',
  },
  Pool: {
    icon: 'ficon-pool',
  },
  Onsen: {
    icon: 'ficon-regular-spa-sauna',
  },
  // jalan
  Fitness: {
    icon: 'ficon-fitness-center',
  },
  Field: {
    icon: 'ficon-regular-gateball-field',
  },
  'Indoor swimming pool': {
    icon: 'ficon-indoor-poor',
  },
  'Outdoor swimming pool': {
    icon: 'ficon-outdoor-pool',
  },
  'Table tennis': {
    icon: 'ficon-table-tennis',
  },
  'Hearth plate': {
    icon: 'ficon-confirmation-instant',
  },
  'Banquet hall': {
    icon: 'ficon-meeting-banquet',
  },
  BBQ: {
    icon: 'ficon-bbq-facilities',
  },
  Lounge: {
    icon: 'ficon-club-lounge-access',
  },
  'Business center': {
    icon: 'ficon-business-center',
  },
  'Non smoking room': {
    icon: 'ficon-non-smoking-room',
  },
  'Ice maker': {
    icon: 'ficon-confirmation-instant',
  },
  'Drying room': {
    icon: 'ficon-confirmation-instant',
  },
  Bowling: {
    icon: 'ficon-bowling-alley',
  },
  Billiards: {
    icon: 'ficon-billiards',
  },
  Parking: {
    icon: 'ficon-valet-parking',
  },
  'Room service': {
    icon: 'ficon-confirmation-instant',
  },
  'Laundry service': {
    icon: 'ficon-laundry-service',
  },
  'Day use': {
    icon: 'ficon-confirmation-instant',
  },
  Massage: {
    icon: 'ficon-massage',
  },

  'Rental ski': {
    icon: 'ficon-regular-ski-clothes-rental',
  },
  'Rental board': {
    icon: 'ficon-confirmation-instant',
  },
  Golf: {
    icon: 'ficon-golf-course-on-site',
  },
  Fishing: {
    icon: 'ficon-regular-seine-fishing',
  },
  Paragliding: {
    icon: 'ficon-confirmation-instant',
  },
  'Horse riding': {
    icon: 'ficon-horse-riding',
  },
  Diving: {
    icon: 'ficon-regular-skin-diving',
  },
  Rafting: {
    icon: 'ficon-confirmation-instant',
  },
  Canoe: {
    icon: 'ficon-canoe',
  },
  'Pottery experience': {
    icon: 'ficon-confirmation-instant',
  },
  'Soba cooking': {
    icon: 'ficon-confirmation-instant',
  },
  Pet: {
    icon: 'ficon-pets-allowed',
  },
  'Pet (only with cage)': {
    icon: 'ficon-pets-allowed',
  },
  'Pet (able to bring in room/lounge)': {
    icon: 'ficon-pet-allowed-room',
  },
  'Pet (with bath/hot spring for pet)': {
    icon: 'ficon-regular-pet-can-bath-in-room',
  },
  'Bike rental for bicycles': {
    icon: 'ficon-bicycle-rental',
  },
  'Japanese chess': {
    icon: 'ficon-confirmation-instant',
  },
  'Go (game)': {
    icon: 'ficon-confirmation-instant',
  },
  'Mah-jong': {
    icon: 'ficon-confirmation-instant',
  },
  'Aesthetic service': {
    icon: 'ficon-regular-aesthetic-salon',
  },
};

export const HotelBathEquipment = {
  Shampoo: {
    icon: 'ficon-shampoo',
  },
  'Hair Conditioner': {
    icon: 'ficon-hair-dryer',
  },
  'Body Soap': {
    icon: 'ficon-confirmation-instant',
  },
  Soap: {
    icon: 'ficon-confirmation-instant',
  },
  Towel: {
    icon: 'ficon-towels',
  },
  'Bath towel': {
    icon: 'ficon-towels',
  },
  Razor: {
    icon: 'ficon-regular-razor',
  },
  Comb: {
    icon: 'ficon-salon',
  },
  'Hair Brush': {
    icon: 'ficon-regular-toothbrush',
  },
  Cotton: {
    icon: 'ficon-confirmation-instant',
  },
  'Cotton swab': {
    icon: 'ficon-confirmation-instant',
  },
  Hairdryer: {
    icon: 'ficon-hair-dryer',
  },
  'Hair Tonic': {
    icon: 'ficon-confirmation-instant',
  },
  'Shaving Lotion': {
    icon: 'ficon-confirmation-instant',
  },
};

export interface IRoomFilters {
  boardTypes: Array<{ key: string; label: string; count: number }>;
  roomTypes: Array<{ key: string; label: string; count: number }>;
  roomProviders: Array<{ key: string; label: string; count: number }>;
}

export interface ISelectedRoomTypes {
  noOfAdult: number;
  noOfChild: number;
  roomTypes: Array<{
    category: string | undefined;
    name: string | undefined;
    roomTypeCode: string | undefined;
    roomTypeId: string | undefined;
    supplier: string | undefined;
    plans: Array<{
      name: string | undefined;
      currency: string | undefined;
      code: string | undefined;
      boardType: string | undefined;
      price: number;
      selectedRooms: number;
      roomPlanId: string;
    }>;
  }>;
}
